import { TextField } from '@mui/material'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'

/**
 * Renders a text input field wrapped in a react-hook-form Controller component.
 *
 * @param {string} props.name - The name of the input field.
 * @param {string} props.label - The label for the input field.
 * @param {Object} props.control - The react-hook-form control object.
 * @param {Object} props.errors - The specific error object for the input field from react-hook-form.
 * @param {Object} props... - Additional props to be passed to the TextField component.
 * @returns {JSX.Element} - The rendered text input field.
 */
const FormInputTextCharacterLimit = ({ name, label, control, errors, ...props }) => {
    const CHARACTER_LIMIT = 200

    return (
        <Controller
            control={control}
            name={name}
            render={({ field: { onChange, value, ...field } }) => (
                <TextField
                    {...field}
                    type="text"
                    variant="outlined"
                    label={label}
                    inputProps={{
                        maxLength: CHARACTER_LIMIT, 
                    }}
                    error={!!errors}
                    helperText={errors ? errors.message : `${value?.length || 0}/${CHARACTER_LIMIT}`} 
                    value={value || ''}
                    onChange={onChange} 
                    {...props}
                />
            )}
        />
    )
}

FormInputTextCharacterLimit.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    control: PropTypes.object.isRequired,
    errors: PropTypes.object, // Specific error object for this input
}

export default FormInputTextCharacterLimit
